export const actionTypePrefix = '@@header';
export const reduxKey = '@@header';

//# sourceMappingURL=constants.js.map